import BaseCaptchaService from './base_captcha_service';

export default class DisabledCaptchaService extends BaseCaptchaService {
  isDisabled = () => true;
}
